import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AuditSignup() {
  const nav = useNavigate();
  const { signup } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form.name, form.email, form.password);
      toast.success("Cuenta creada");
      nav("/audit", { replace: true });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div data-surface="audit" className="min-h-screen bg-[hsl(var(--audit-bg))] px-6 py-12">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[hsl(var(--audit-muted))]"><ArrowLeft size={14} /> Web pública</Link>
        <div className="mt-6 rounded-md border border-[hsl(var(--audit-border))] bg-white p-8">
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-[hsl(var(--audit-muted))]">Audit Framework</div>
          <h1 className="mt-1 text-2xl font-bold">Crear cuenta</h1>
          <form onSubmit={submit} data-testid="audit-signup-form" className="mt-6 grid gap-4">
            <label className="block">
              <span className="text-xs font-mono uppercase tracking-widest text-[hsl(var(--audit-muted))]">Nombre</span>
              <input required data-testid="audit-signup-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-2 text-sm" />
            </label>
            <label className="block">
              <span className="text-xs font-mono uppercase tracking-widest text-[hsl(var(--audit-muted))]">Correo</span>
              <input required type="email" data-testid="audit-signup-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-2 text-sm" />
            </label>
            <label className="block">
              <span className="text-xs font-mono uppercase tracking-widest text-[hsl(var(--audit-muted))]">Contraseña (mín. 8 caracteres)</span>
              <input required type="password" minLength={8} data-testid="audit-signup-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-2 text-sm" />
            </label>
            <button type="submit" disabled={loading} data-testid="audit-signup-submit" className="inline-flex items-center justify-center gap-2 rounded-md bg-[hsl(var(--audit-text))] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">
              <UserPlus size={14} /> {loading ? "Creando…" : "Crear cuenta"}
            </button>
          </form>
          <p className="mt-4 text-sm text-[hsl(var(--audit-muted))]">
            ¿Ya tienes cuenta? <Link to="/audit/login" className="font-semibold underline">Entra</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
